module.exports = __webpack_public_path__ + "img/Warlock-undead-m-70.e1ccb984.gif";